import { getApi } from '../../utils/api'

export function checkTask(id) {
  return getApi({ endpoint: `/api/async-mass-action/task/${id}/` })
}
